exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list_from_PendingPricingRequestsList-css_2AZ {\r\n  padding-bottom: 32px;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"list": "list_from_PendingPricingRequestsList-css_2AZ"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--3-1!./node_modules/postcss-loader/lib??ref--3-2!./app/web/src/components/pricing/PendingPricingRequestsList.css
// module id = ./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/pricing/PendingPricingRequestsList.css
// module chunks = 0